import type { MouseEvent } from 'react';
import FJClose from './FJClose';
import styles from './FJModalClose.module.less';
import classNames from 'classnames';

interface FJModalCloseProps {
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
    className?: string;
}

function FJModalClose({ onClick, className }: FJModalCloseProps) {
    return (
        <div className={classNames(styles.close, className)} onClick={onClick}>
            <FJClose />
        </div>
    );
}

export default FJModalClose;
